import type {
    CatalogItemInput,
    DiffAddedItem,
    DiffFieldChange,
} from '~/api/types'

// 변경 맵(changes) → 반영 필드(각 필드의 to 값). null/undefined는 그대로 전달한다.
export function changesToFields(
    changes: Record<string, DiffFieldChange>
): Partial<CatalogItemInput> {
    const out: Record<string, DiffFieldChange['to']> = {}
    for (const [k, v] of Object.entries(changes)) out[k] = v.to
    return out as Partial<CatalogItemInput>
}

// 추가 항목 → 반영(create) 입력. 식별 필드 + 콘텐츠 필드를 함께 보낸다.
// maxScore는 create 필수(>0)라 반드시 포함해야 한다(빠지면 422). 나머지 미제공 필드는
// 서버 기본값(assessment_type·industry·criteria_* 등)으로 둔다 — 이후 항목 편집에서 보완.
export function refToFields(ref: DiffAddedItem): Partial<CatalogItemInput> {
    return {
        part: ref.part,
        classification: ref.classification,
        scale: ref.scale,
        itemNumber: ref.itemNumber,
        title: ref.title,
        maxScore: ref.maxScore,
        majorCategory: ref.majorCategory ?? undefined,
        middleCategory: ref.middleCategory ?? undefined,
        scoringScale: ref.scoringScale ?? undefined,
        guidance: ref.guidance ?? undefined,
        dataType: ref.dataType ?? undefined,
        scoringLogic: ref.scoringLogic ?? undefined,
    }
}

export function toggle<T>(prev: Set<T>, key: T): Set<T> {
    const next = new Set(prev)
    if (next.has(key)) next.delete(key)
    else next.add(key)
    return next
}
